import { render, staticRenderFns } from "./BscWallet.vue?vue&type=template&id=67423576&scoped=true"
import script from "./BscWallet.vue?vue&type=script&lang=js"
export * from "./BscWallet.vue?vue&type=script&lang=js"
import style0 from "./BscWallet.vue?vue&type=style&index=0&id=67423576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67423576",
  null
  
)

export default component.exports